import { Reveal } from "@/components/Reveal";

const B = ({ children }) => <strong className="font-bold text-white">{children}</strong>;

export const Manifesto = () => (
  <section id="manifesto" className="relative py-20 lg:py-36 px-6" data-testid="manifesto-section">
    <div className="max-w-[900px] mx-auto space-y-14 sm:space-y-20">
      <Reveal>
        <p className="text-xs tracking-[0.3em] uppercase text-titanium mb-10">Manifesto</p>
        <p className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-[-0.03em] leading-[1.15] text-white" data-testid="manifesto-intro">
          In un mondo in continuo cambiamento, dall'esplosione di Internet all'era dell'AI, alcune cose sono rimaste{" "}
          <span className="font-semibold">ostinatamente uguali.</span>
        </p>
      </Reveal>
      <Reveal>
        <p className="text-2xl sm:text-3xl lg:text-4xl tracking-[-0.025em] leading-[1.3] text-titanium">
          <B>Curriculum fotocopia.</B> Manager che perdono ore a filtrare candidati. Aziende che bruciano migliaia di
          euro per ruoli scoperti, tradite da un sistema basato solo sulle competenze.
        </p>
      </Reveal>
      <Reveal>
        <p className="text-2xl sm:text-3xl lg:text-4xl font-light tracking-[-0.025em] leading-[1.3] text-titanium">
          Prodigy nasce da un'idea radicale:{" "}
          <B>le competenze invecchiano, l'attitudine e il carattere sono immutabili.</B>
        </p>
      </Reveal>
      <Reveal>
        <p className="text-4xl sm:text-5xl lg:text-6xl font-light tracking-[-0.04em] leading-[1.08] text-white">
          Ecco perché non valutiamo le competenze classiche, ma <span className="font-extrabold">le Persone.</span>
        </p>
      </Reveal>
      <Reveal>
        <p className="text-lg sm:text-xl leading-relaxed text-titanium max-w-2xl">
          Analizziamo le predisposizioni per valorizzare non solo quello che sanno fare, ma{" "}
          <span className="text-white font-medium">chi sono.</span> Prima ancora del loro ingresso nel mondo lavorativo.
        </p>
      </Reveal>
    </div>
  </section>
);
